import { inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Transporter } from '../models/transporter.model';
import { createRequestOption, mapAsBody } from '../app/shared/util/request-util';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { IBaryTableFetchService } from './i-bary-table-fetch-service';
import { ApiProviderService } from './api-provider.service';
import { NewShopModel } from '../models/new.shop.model';
import { map } from 'rxjs/operators';

export type EntityResponseType = HttpResponse<Transporter>;
export type EntityArrayResponseType = HttpResponse<Transporter[]>;

@Injectable({ providedIn: 'root' })
export class TransporterService implements IBaryTableFetchService<Transporter> {
  readonly #apiProvider = inject(ApiProviderService);

  protected resourceUrl: string = API_ENDPOINTS.TRANSPORTER;

  // @deprecated use addNewTransporter
  public create(transporter: Transporter): Observable<EntityResponseType> {
    return this.#apiProvider.post<Transporter>(this.resourceUrl, transporter);
  }

  public addNewTransporter(transporter: NewShopModel): Observable<Transporter> {
    return this.#apiProvider.post<Transporter>(this.resourceUrl, transporter).pipe(
      mapAsBody,
      map((data: any) => new Transporter(data))
    );
  }

  public update(transporter: Transporter): Observable<EntityResponseType> {
    return this.#apiProvider.put<Transporter>(`${this.resourceUrl}/${transporter.id}`, transporter);
  }

  partialUpdate(transporter: Transporter): Observable<EntityResponseType> {
    return this.#apiProvider.patch<Transporter>(this.resourceUrl, transporter);
  }

  find(id: number): Observable<EntityResponseType> {
    return this.#apiProvider.get<Transporter>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  public getByCustomerId(): Observable<Transporter> {
    return this.#apiProvider.get<Transporter>(`${this.resourceUrl}`, { observe: 'response' }).pipe(mapAsBody);
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.#apiProvider.get<Transporter[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.#apiProvider.delete(`${this.resourceUrl}/${id}`);
  }

  fillDataToShow(entities: Transporter[]): Observable<Transporter[]> {
    return of(entities);
  }

  updateOrder(entities: Transporter[]): Observable<Transporter[]> {
    return of(entities);
  }
}
